<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(v-if="invoice.coupons.length > 0")
      v-card-title.h6.basic800--text {{ $t('remove_coupon') }}
      v-card-text.p2.primary500--text
        | {{ $t('remove_coupon_confirmation') }}
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='danger500' depressed height=32 :loading="isLoading"  @click='startDelete')
          .button-AA-small.basic100--text {{ $t('remove') }}

    v-card(v-else)
      v-card-title
        div.h6.basic800--text {{ $t('coupon_code') }}
      v-divider.basic300
      v-card-text.pt-4.pb-0
        .coupon-code
          p.mb-1.label.basic600--text.text-uppercase {{ $t('field_coupon_code.label') }}
          v-text-field.mt-2(v-model='couponCode' :placeholder="$t('field_coupon_code.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint)

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('close') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 :loading="isLoading" @click='clickApply' :disabled="!couponCode")
          .button-AA-small.basic100--text {{ $t('apply') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ApplyCouponDialog',
  props: ['open', 'invoice'],
  data: () => ({
    couponCode: null,
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.invoice.coupons.length > 0) {
      this.couponCode = this.invoice.coupons[0].code
    }
    // this.fetchHistory()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    startDelete () {
      this.isLoading = true
      this.$axios.post(`/invoices/${this.invoice.pid}/remove_coupon`, { code: this.couponCode })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.coupon_code_removed')])
          this.$emit('applied')
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickApply () {
      this.isLoading = true
      this.$axios.post(`/invoices/${this.invoice.pid}/apply_coupon`, { code: this.couponCode })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.coupon_code_applied')])
          this.$emit('applied')
          this.showModal = false
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.detail) {
            this.showMessage(['error', e.response.data.detail])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "field_coupon_code": {
      "label": "Enter code",
      "placeholder": "Write a valid coupon code here"
    },
    "remove_coupon": "Remove coupon",
    "remove_coupon_confirmation": "Are you sure you want to remove this coupon code?"
  },
  "id": {
    "field_coupon_code": {
      "label": "Masukan kode",
      "placeholder": "Tuliskan kode kupon yang valid di sini"
    },
    "remove_coupon": "Hapus kupon",
    "remove_coupon_confirmation": "Anda yakin ingin menghapus kode kupon ini?"
  }
}
</i18n>
